import { useQuery } from '@tanstack/react-query'

import { dataOrThrow } from '@snootsvet/shared/portal'

import { usePortalApi } from '@/customer/hooks/use-api'

export const invoiceQueryKey = (invoiceId: string) => ['invoice', invoiceId] as const

/** Fetches a single invoice via `GET /portal/billing/invoices/:id`. */
export function useGetInvoice(invoiceId: string | undefined) {
  const api = usePortalApi()
  return useQuery({
    queryKey: invoiceQueryKey(invoiceId ?? ''),
    enabled: !!invoiceId,
    queryFn: async () =>
      dataOrThrow(await api.get('/billing/invoices/:id', { params: { id: invoiceId ?? '' } })),
  })
}
